import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { subscriptionService } from '../../application/SubscriptionService';
import * as routing from '../../constants/Routing';
import useErrorMiddleware from '../errorMiddleware/useErrorMiddleware';
import { useShowSnackbarMessage } from '../snackbarMessage/useShowSnackbarMessage';

type UseCreatePortalSessionResponseProps = ServiceResponse<Function, string>;

// Hooks act as 'Adapter' layer.
const useCreatePortalSession = (): UseCreatePortalSessionResponseProps => {
  const [session, setSession] = useState<string>();
  const { sessionExpiredLogout } = useErrorMiddleware();
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const { isLoading, isSuccess, isError, refetch } = useQuery(
    [`planner_portal_session`],
    () => subscriptionService.createPortalSession(`${window.location.origin}${routing.SETTINGS.BILLING.SUBSCRIPTION}`),
    {
      refetchOnWindowFocus: false,
      onSuccess: (invoices) => {
        setSession(invoices);
      },
      onError: (err: any) => {
        console.info(`Retrieve Subscription Invoices Error: `, err?.response);

        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }

        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    error: isError,
    isLoading: isLoading,
    success: isSuccess,
    data: session,
    run: refetch,
  };
};

export default useCreatePortalSession;
